export default __webpack_public_path__ + "static/media/imgLiif.ae03fbff.webp";